import { render, staticRenderFns } from "./rewardsConfiguration.vue?vue&type=template&id=3f5c76ce"
import script from "./rewardsConfiguration.vue?vue&type=script&lang=js"
export * from "./rewardsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports